import CircleCheckFilledSvg from '@assets/images/svg/circle-check-filled.svg';
import React from 'react';
import { View } from 'react-native';

export interface CircleCheckFilledIconProps {
  size?: number;
  color?: string;
}

/**
 * Filled circle-check (Figma reservation / Iskan loan success).
 * Default color matches original SVG fill (#388E3C).
 */
export function CircleCheckFilledIcon({
  size = 14,
  color = '#388E3C',
}: Readonly<CircleCheckFilledIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircleCheckFilledSvg width={size} height={size} color={color} />
    </View>
  );
}

export default CircleCheckFilledIcon;
